import "../../assets/css/roadMap.css"

const PostSaleRoadMap = () => {
    return (
        <>
         <div className="post-bg text-white">
             <div className="container mt-md-5 mt-2">
                 <div className="row">
                     <div className="col-12 mb-5">
                         <h1 className="sec-heading mb-4 text-center">Post Sale Road Map</h1>
                     </div>
                     
                 </div>
             </div>
         </div>
        <div class="timeline"  data-aos="fade-up"
        data-aos-duration="1500"
        >
        <div class="container-map left"  >
          <div class="date" 
          data-aos="fade-left"
          data-aos-duration="800"
          >15 Dec</div>
          <strong 
          class="icon fa fa-home" 
          data-aos="fade-right"
          data-aos-duration="1000"
          >1</strong>
          <div class="content" 
         data-aos="fade-right"
         data-aos-duration="1500"
          >
            <h2>Lorem ipsum dolor sit amet</h2>
            <p>
              Lorem ipsum dolor sit amet elit. Aliquam odio dolor, id luctus erat sagittis non. Ut blandit semper pretium.
            </p>
          </div>
        </div>
        <div class="container-map right">
          <div class="date"
            data-aos="fade-right"
            data-aos-duration="800"
            //data-aos-offset="1200"
          >22 Oct</div>
          <strong class="icon fa fa-home"   data-aos="fade-left"
            data-aos-duration="800"
            //data-aos-offset="1200"
            >2</strong>
          <div class="content"         
          data-aos="fade-left"
          data-aos-duration="1500"
          
          //data-aos-offset="1200"
          >
            <h2>Lorem ipsum dolor sit amet</h2>
            <p>
              Lorem ipsum dolor sit amet elit. Aliquam odio dolor, id luctus erat sagittis non. Ut blandit semper pretium.
            </p>
          </div>
        </div>
        <div class="container-map left">
          <div class="date"
            data-aos="fade-left"
            data-aos-duration="800"
            //data-aos-offset="1200"
          >10 Jul</div>
          <strong class="icon fa fa-home"
            data-aos="fade-right"
            data-aos-duration="1000"
            //data-aos-offset="1200"
          >3</strong>
          <div class="content"         data-aos="fade-right"
          data-aos-duration="2500"
          //data-aos-offset="1200"
          >
            <h2>Lorem ipsum dolor sit amet</h2>
            <p>
              Lorem ipsum dolor sit amet elit. Aliquam odio dolor, id luctus erat sagittis non. Ut blandit semper pretium.
            </p>
          </div>
        </div>
        <div class="container-map right">
          <div class="date"
            data-aos="fade-right"
            data-aos-duration="800"
            //data-aos-offset="1200"
          >18 May</div>
          <strong class="icon fa fa-home"   data-aos="fade-left"
            data-aos-duration="800"        
            //data-aos-offset="1200"
            >4</strong>
          <div class="content"         data-aos="fade-left"
          data-aos-duration="1500"        
          //data-aos-offset="1200"
          >
            <h2>Lorem ipsum dolor sit amet</h2>
            <p>
              Lorem ipsum dolor sit amet elit. Aliquam odio dolor, id luctus erat sagittis non. Ut blandit semper pretium.
            </p>
          </div>
        </div>
        <div class="container-map left">
          <div class="date"
            data-aos="fade-left"
            data-aos-duration="800"
            //data-aos-offset="1200"
          >10 Feb</div>
          <strong class="icon fa fa-home"
            data-aos="fade-right"
            data-aos-duration="1000"
            //data-aos-offset="1200"
          >5</strong>
          <div class="content"         data-aos="fade-right"
          data-aos-duration="1500"        
          //data-aos-offset="1200"
          >
            <h2>Lorem ipsum dolor sit amet</h2>
            <p>
              Lorem ipsum dolor sit amet elit. Aliquam odio dolor, id luctus erat sagittis non. Ut blandit semper pretium.
            </p>
          </div>
        </div>
        <div class="container-map right">
          <div class="date"   data-aos="fade-right"
            data-aos-duration="800"        
            //data-aos-offset="1200"
            >01 Jan</div>
          <strong class="icon fa fa-home"   data-aos="fade-left"
            data-aos-duration="800"        
            //data-aos-offset="1200"
            >6</strong>
          <div class="content"         data-aos="fade-left"
          data-aos-duration="1500"       
           //data-aos-offset="1200"
           >
            <h2>Lorem ipsum dolor sit amet</h2>
            <p>
              Lorem ipsum dolor sit amet elit. Aliquam odio dolor, id luctus erat sagittis non. Ut blandit semper pretium.
            </p>
          </div>
        </div>
      </div>
      </>
    )
}

export default PostSaleRoadMap
